/* Photo -> clean outline line art, in the browser.

   XDoG (extended difference of Gaussians): two blurs of different radius are
   subtracted and the result is thresholded with a soft tanh falloff. That gives
   continuous outline strokes instead of the grey pencil shading a colour-dodge
   sketch produces, which is what the laser actually needs.

   grey -> pre-smooth (kills skin texture and fabric weave)
        -> DoG -> centre-weighted soft threshold -> despeckle -> etch depth

   TAU is 1.0 on purpose. At 0.993 a flat area still yields a small positive DoG,
   which the threshold then reads as mid grey and the whole frame goes muddy.
   At 1.0 a flat area is exactly zero, so only real edges produce strokes.

   The vignette term raises the bar towards the frame edges. Portrait subjects sit
   in the middle, so this thins out busy backgrounds without touching the face.
   It cannot replace real subject segmentation: a densely textured background
   (foliage, brickwork, a crowd) will still speckle. Plain or blurred backgrounds
   give by far the cleanest result, which is what the upload hint asks for.

   window.VellunaLineArt(canvasWithPhoto, opts)
   opts: { ink: 0..1 etch depth, contrast: ~0.8..2.6 higher = fewer, stronger lines }
*/
(function(){
  function tanh_(v){ if(v>18)return 1; if(v<-18)return -1; var e=Math.exp(2*v); return (e-1)/(e+1); }

  function boxBlur(src,w,h,r){
    if(r<1) return src;
    var tmp=new Float32Array(src.length),out=new Float32Array(src.length),i,j,s,c,q;
    for(j=0;j<h;j++){for(i=0;i<w;i++){s=0;c=0;
      for(q=-r;q<=r;q++){var xx=i+q;if(xx<0||xx>=w)continue;s+=src[j*w+xx];c++;}
      tmp[j*w+i]=s/c;}}
    for(i=0;i<w;i++){for(j=0;j<h;j++){s=0;c=0;
      for(q=-r;q<=r;q++){var yy=j+q;if(yy<0||yy>=h)continue;s+=tmp[yy*w+i];c++;}
      out[j*w+i]=s/c;}}
    return out;
  }

  window.VellunaLineArt=function(c,opts){
    opts=opts||{};
    var INK=(opts.ink==null?0.7:opts.ink);
    var CON=(opts.contrast==null?1.7:opts.contrast);
    var VIG=(opts.vignette==null?4.0:opts.vignette);
    var x=c.getContext('2d'),w=c.width,h=c.height;
    var im=x.getImageData(0,0,w,h),p=im.data,n=w*h;

    var g=new Float32Array(n);
    for(var i=0,j=0;i<p.length;i+=4,j++){ g[j]=0.299*p[i]+0.587*p[i+1]+0.114*p[i+2]; }

    var unit=Math.min(w,h);
    var s=boxBlur(g,w,h,Math.max(1,Math.round(unit/300)));
    var r1=Math.max(1,Math.round(unit/280));
    var r2=Math.max(r1+1,Math.round(r1*2.4));
    var b1=boxBlur(s,w,h,r1), b2=boxBlur(s,w,h,r2);

    var PHI=0.60, EPS0=-(CON-1.0)*2.5;
    var cx=w/2, cy=h/2, lin=new Float32Array(n);
    for(var y=0;y<h;y++){
      var ny=(y-cy)/cy;
      for(var xx2=0;xx2<w;xx2++){
        var nx=(xx2-cx)/cx;
        var dist=Math.sqrt(nx*nx+ny*ny)/1.4142;
        var eps=EPS0-dist*dist*VIG;
        var k=y*w+xx2, dd=b1[k]-b2[k];
        var v = dd>=eps ? 255 : 255*(1+tanh_(PHI*(dd-eps)));
        lin[k]= v<0?0 : (v>255?255:v);
      }
    }

    var out=new Float32Array(n);
    for(var y2=0;y2<h;y2++){
      for(var x2=0;x2<w;x2++){
        var idx=y2*w+x2, val=lin[idx];
        if(val>200){ out[idx]=val; continue; }
        var near=0;
        for(var dy=-1;dy<=1;dy++){
          var yy2=y2+dy; if(yy2<0||yy2>=h)continue;
          for(var dx=-1;dx<=1;dx++){
            var xz=x2+dx; if(xz<0||xz>=w||(dx===0&&dy===0))continue;
            if(lin[yy2*w+xz]<200)near++;
          }
        }
        out[idx]= near>=2 ? val : 255;
      }
    }

    for(var q=0;q<n;q++){
      var o=q*4, vv=255-(255-out[q])*INK;
      p[o]=p[o+1]=p[o+2]=vv; p[o+3]=255;
    }
    x.putImageData(im,0,0);
    return c;
  };
})();
